import templateStr from 'text!./SWOS.html';
import moment from 'moment';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            latestPeriod: '=',
            policyNumber: '=',
            swosOnly: '=',
            hideForm: '&',
            cewScreens: '&',
            cewPresent: '=',
            selectedData: '=?'
        },
        controller: ['$rootScope', '$state', '$scope', 'PolicyService', '$window', '$q', 'ModalService', 'ViewModelService', 'CancellationService', '$filter', '$stateParams', function ($rootScope, $state, $scope, PolicyService, $window, $q, ModalService, ViewModelService, CancellationService, $filter, $stateParams) {
            $scope.period = $scope.latestPeriod;
            var location = { addressLine1: "", country: "US", addressLine2: "", addressLine3: "", companyName: "", city: "", state: "", additionalInfo: "", postalCode: "", publicId: "", county: "" };
            $scope.addressLine1 = "";
            $scope.companyName = "";
            //$scope.closeSWOS=false;
            $scope.location = ViewModelService.create(location, 'pc', 'edge.capabilities.address.dto.MSFCOInsuranceDTO');
            $scope.CEWPresent = $scope.cewPresent;
            $scope.isBWOS = $scope.selectedData;

            // Check whether SWOS is already added to the jobNumber
            var SWOSExist = PolicyService.getExistingSWOS($scope.period);
            SWOSExist.then(function (res) {
                if (res.sWOSExists != undefined && res.sWOSExists) {
                    $scope.searchResult = true;
                    $scope.newCompany = true;
                    // $scope.swosAlreadyExist=true;
                    $scope.location.companyName = res.companyName;
                    $scope.location.addressLine1 = res.addressLine1;
                    $scope.location.addressLine2 = res.addressLine2;
                    $scope.location.addressLine3 = res.addressLine3;
                    $scope.location.city = res.city;
                    $scope.location.county = res.county;
                    $scope.location.state = res.state;
                    $scope.location.additionalInfo = res.additionalInfo;
                    $scope.location.postalCode = res.postalCode;
                    $scope.swosPublicId = res.publicId;
                }if (res.existingSWOS != undefined && res.existingSWOS) {
                    $scope.searchResult = true;
                    $scope.existingCompany = true;
                    $scope.swosAlreadyExist = true;
                    $scope.existingCompanyName = res.companyName;
                    $scope.existingAddressLine1 = res.addressLine1;
                    $scope.existingAddressLine2 = res.addressLine2;
                    $scope.existingAddressLine3 = res.addressLine3;
                    $scope.existingCity = res.city;
                    $scope.existingCounty = res.county;
                    $scope.existingState = res.state;
                    $scope.existingAdditionalInfo = res.additionalInfo;
                    $scope.existingPostalCode = res.postalCode;
                    $scope.existingPublicId = res.publicId;
                }
            }, function () {
                $scope.disableSubmit = false;
                $scope.searchAgain();
            });

            $scope.companySearch = function () {
                var companyNameEnt = angular.element('.companyName').val();

                if (companyNameEnt == undefined || companyNameEnt.length < 5) {
                    $scope.companyNameEmpty = true;
                    return;
                } else {
                    $scope.companyNameEmpty = false;
                }
                $scope.disableSubmit = true;
                var data = { country: "US", contactType: "company", contactName: companyNameEnt };
                var servicePromise = PolicyService.getPotentialExistingAccounts(data);
                servicePromise.then(function (res) {
                    $scope.disableSubmit = false;
                    $scope.searchResult = true;
                    $scope.searchData = res;
                }, function () {
                    $scope.disableSubmit = false;
                    $scope.searchAgain();
                });
            };

            /** Quote Policy Change * */
            $scope.quotePolicyChange = function (data) {
                $scope.disableSubmit = true;
                $scope.closeSWOS = true;
                $scope.$emit("initiateQuote", data);
            };

            /** Quote and Bind Policy Change **/
            $scope.quoteAndBindPolicyChange = function () {
                $scope.disableSubmit = true;
                $scope.$emit("initiateQuoteAndBind");
            };

            /** Previous Screen * */
            $scope.Previous = function () {
                $scope.$emit("SWOSPrevious");
            };
            $scope.submitExistingSWOS = function (filter) {
                $scope.disableSubmit = true;
                var addInfo = "";

                if (!$scope.mailPresent) {
                    addInfo = angular.element('.additionalInfo').val();
                } else if ($scope.mailPresent) {
                    addInfo = angular.element('.additionalInfoMail').val();
                } else {
                    addInfo = angular.element('.additionalInfoExist').val();
                }
                var data = {};

                if ($scope.existingCompanyData != undefined) {
                    data = { CompanyName: $scope.existingCompanyData.accountHolder.displayName,
                        publicID: $scope.existingCompanyData.accountHolder.publicID,
                        additionalInfo: addInfo, accountNumber: $scope.existingCompanyData.accountNumber };
                } else if (data.publicId == undefined) {
                    data = { CompanyName: $scope.existingCompanyName,
                        publicID: $scope.existingPublicId,
                        additionalInfo: $scope.existingAdditionalInfo, accountNumber: $scope.existingCompanyData.accountNumber };
                }
                var SWOSPromise = PolicyService.submitSWOSForExistingCompany($scope.period, false, data);
                SWOSPromise.then(function (res) {
                    $scope.searchResult = false;

                    if (res == "SWOSBound") {
                        $rootScope.SWOS = "swosSubmitted"; // $rootScope.$broadcast("swosSubmitted");
                        $rootScope.restrictNavigation = false;
                        $state.go('account-policy-details', {
                            policyNumber: $scope.policyNumber
                        });
                    }

                    if (filter == "quoteAndNext") {
                        $scope.cewScreens();
                    } else {
                        if (res == "SWOSSubmitted") {
                            $scope.quotePolicyChange(data);
                        }
                    }
                    $scope.disableSubmit = false;
                }, function (dat) {
                    $scope.disableSubmit = false; //console.log(JSON.stringify(dat.baseError.error.code))
                    if (dat.baseError.error.code != undefined && dat.baseError.error.code == '-32603') {
                        ModalService.showError('', data.CompanyName + ' already added to waiver of subrogation.');
                    } else {
                        ModalService.showError('', 'An error occurred while attempting to save contact.');
                    }
                });
            };

            $scope.getData = function () {
                // $scope.$apply(function () {
                $scope.addressLine1 = $scope.location.addressLine1.value;
                $scope.addressLine2 = $scope.location.addressLine2.value;
                $scope.addressLine3 = $scope.location.addressLine3.value;
                $scope.city = $scope.location.city.value;
                $scope.county = $scope.location.county.value;
                $scope.state = $scope.location.state.value.code;
                $scope.postalCode = $scope.location.postalCode.value;
                $scope.additionalInfo = $scope.location.additionalInfo.value;
                $scope.companyName = $scope.location.companyName.value;
                if ($scope.swosPublicId == undefined) $scope.swosPublicId = " ";

                if ($scope.addressLine1 == undefined || $scope.addressLine1.trim() == '' || $scope.county.trim() == '' || $scope.county == undefined || $scope.companyName == undefined || $scope.companyName.trim() == '' || $scope.city == undefined || $scope.city.trim() == '' || $scope.state == undefined || $scope.postalCode == undefined || $scope.postalCode.trim() == '') {
                    return "ValidationError";
                }
                var dat = { PublicId: $scope.swosPublicId, Country: "US", County: $scope.county, CompanyName: $scope.companyName, State: $scope.state, AddressLine1: $scope.addressLine1, AddressLine2: $scope.addressLine2, AddressLine3: $scope.addressLine3, City: $scope.city, AdditionalInfo: $scope.additionalInfo, PostalCode: $scope.postalCode };

                return dat;
                /* }); */
            };

            $scope.submitNewBWOS = function (filter) {
                // form.submitted = true; 
                // if (form.invalid) {
                // 	return;
                // }  
                $scope.disableSubmit = true;
                // var data = $scope.getData();


                var SWOSPromise = PolicyService.submitSWOSForNewCompany($scope.period, false, null);
                SWOSPromise.then(function (res) {
                    $scope.searchResult = false;
                    if (res == "SWOSBound") {
                        $rootScope.restrictNavigation = false;
                        $rootScope.SWOS = "swosSubmitted"; // $rootScope.$broadcast("swosSubmitted");
                        $state.go('account-policy-details', {
                            policyNumber: $scope.policyNumber
                        });
                    }
                    if (filter == "quoteAndNext") {
                        $scope.cewScreens();
                    } else {
                        if (res == "SWOSSubmitted") {
                            $scope.quotePolicyChange();
                        }
                    }
                    $scope.disableSubmit = false;
                }, function (error) {
                    $scope.disableSubmit = false;
                    //$scope.errorInSubmission=true;
                    ModalService.showError('', error.baseError.error.message);
                }); //$scope.cewScreens(); 
            };
            $scope.submitNewSWOS = function (filter, form) {

                form.submitted = true;
                if (form.invalid) {
                    return;
                }
                $scope.disableSubmit = true;
                var data = $scope.getData();
                var SWOSPromise = PolicyService.submitSWOSForNewCompany($scope.period, false, data);
                SWOSPromise.then(function (res) {
                    $scope.searchResult = false;
                    if (res == "SWOSBound") {
                        $rootScope.restrictNavigation = false;
                        $rootScope.SWOS = "swosSubmitted"; // $rootScope.$broadcast("swosSubmitted");
                        $state.go('account-policy-details', {
                            policyNumber: $scope.policyNumber
                        });
                    }
                    if (filter == "quoteAndNext") {
                        $scope.cewScreens();
                    } else {
                        if (res == "SWOSSubmitted") {
                            $scope.quotePolicyChange(data);
                        }
                    }
                    $scope.disableSubmit = false;
                }, function (error) {
                    $scope.disableSubmit = false;
                    //$scope.errorInSubmission=true;
                    ModalService.showError('', error.baseError.error.message);
                }); //$scope.cewScreens(); 
            };

            $scope.newQuote = function (account) {
                $scope.existingCompany = true;
                $scope.existingCompanyData = account;
                $scope.mailPresent = false;
                if ($scope.existingCompanyData.mailingAddress != undefined) {
                    $scope.mailPresent = true;
                }
            };

            $scope.newCompanyQuote = function () {
                $scope.existingCompany = false;
                $scope.newCompany = true;
                // $scope.searchResult=false;
            };

            $scope.searchAgain = function () {
                $scope.searchResult = false;
            };

            $scope.withdraw = function () {
                var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this policy change?', '', 'Withdraw', '', 'Cancel').result;
                withdrawModal.then(function (res) {

                    var withdrawPromise = PolicyService.withdrawPolicyTransaction($scope.policyNumber, $scope.period);
                    withdrawPromise.then(function (res) {
                        $rootScope.restrictNavigation = false;
                        $state.go('policies.detail.summary', {
                            'policyNumber': $scope.policyNumber
                        });
                    });
                });
            };

            $scope.saveExitNew = function (form) {
                form.submitted = true;
                if (form.invalid) {
                    return;
                }
                var data = $scope.getData();
                var SWOSPromise = PolicyService.submitSWOSForNewCompany($scope.period, false, data);
                SWOSPromise.then(function (res) {
                    $rootScope.restrictNavigation = false;
                    $state.go('policies.detail.summary', {
                        'policyNumber': $scope.policyNumber
                    });
                    $scope.disableSubmit = false;
                }, function () {
                    $rootScope.restrictNavigation = false;
                    $scope.disableSubmit = false;
                    $state.go('policies.detail.summary', {
                        'policyNumber': $scope.policyNumber
                    });
                });
            };

            $scope.saveExitExisting = function () {

                var addInfo = angular.element('.additionalInfo').val();
                var addInfoExist = angular.element('.additionalInfoExist').val(); /*console.log("addInfoExist-->"+addInfoExist); return;*/
                var data = {};

                if ($scope.existingCompanyData != undefined) {
                    data = { CompanyName: $scope.existingCompanyData.accountHolder.displayName,
                        publicID: $scope.existingCompanyData.accountHolder.publicID,
                        additionalInfo: addInfo };
                } else if (data.publicId == undefined) {
                    data = { CompanyName: $scope.existingCompanyName,
                        publicID: $scope.existingPublicId,
                        additionalInfo: addInfoExist };
                }
                var SWOSPromise = PolicyService.submitSWOSForExistingCompany($scope.period, false, data);
                SWOSPromise.then(function (res) {
                    $rootScope.restrictNavigation = false;
                    $state.go('policies.detail.summary', {
                        'policyNumber': $scope.policyNumber
                    });
                    $scope.disableSubmit = false;
                }, function () {
                    $rootScope.restrictNavigation = false;
                    $scope.disableSubmit = false;
                    $state.go('policies.detail.summary', {
                        'policyNumber': $scope.policyNumber
                    });
                });
            };
            $scope.saveExit = function () {
                $rootScope.restrictNavigation = false;
                $state.go('policies.detail.summary', {
                    'policyNumber': $scope.policyNumber
                });
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/SWOSDirective/SWOSPolicy.js
// module id = 1768
// module chunks = 0